import { onLangChange } from '@hub/shared'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { SubscriptionLike } from 'rxjs'
import './header-text-campaign-format.component.scoped.scss'

interface HeaderTextCampaignFormatProps extends React.HTMLAttributes<HTMLDivElement> {
  campaignFormat: string | 'conversion' | 'awareness' | 'branding'
  date?: string
  icon?: string
}

const HeaderTextCampaignFormat = ({
  campaignFormat = 'awareness',
  icon = 'fa-regular fa-bullseye-arrow',
  date,
}: HeaderTextCampaignFormatProps) => {
  const [t] = useTranslation('headerTextCampaignFormat')
  const onLangChangeSubscription = useRef<SubscriptionLike | undefined>(undefined)
  const [lang, setLang] = useState<string>('en')

  const formatDate = (date?: string | Date) => {
    const dateObj = date ? new Date(date) : new Date()
    return dateObj.toLocaleDateString(lang)
  }

  useEffect(() => {
    onLangChangeSubscription.current = onLangChange.subscribe((lang) => {
      setLang(lang)
    })
    return () => {
      onLangChangeSubscription.current?.unsubscribe()
    }
  }, [])

  if (!campaignFormat) {
    return null
  }

  return (
    <div className="card-to-upload-content">
      <h6>{t(`${campaignFormat}.title`)}</h6>
      <span>
        {t(`${campaignFormat}.text1`)}
        <i className="fa-regular fa-bullseye-arrow lg mx-2"></i>
        {t(`${campaignFormat}.text2`)}
      </span>
      <span className="updated-at">{`${t('updated')} - ${formatDate()}`}</span>
    </div>
  )
}

export default HeaderTextCampaignFormat
